import { VorgangProtokollAction } from '@core/domain';
import { ArrowLeft, RotateCcw, Trash2 } from 'lucide-react';
import { TimelineElement } from '@/components/ui/timeline/timeline-types';
import { VorgangDetailProtokoll } from '@/types';

const TRANSLATION_MAP = {
  [VorgangProtokollAction.DELETED]: 'Gelöscht',
  [VorgangProtokollAction.RESTORED]: 'Wiederhergestellt',
  [VorgangProtokollAction.VORGANG_ZURUECKGESTELLT]: 'Zurückgestellt',
};

export const getTimelineItemForVorgangProtokoll = (
  item: VorgangDetailProtokoll[number],
): [Omit<TimelineElement, 'id'>] | [] => {
  if (String(item.action) === VorgangProtokollAction.ARCHIVIERUNG_ABGEGLICHEN) {
    return [
      {
        date: new Date(item.date),
        title:
          item.details.abgleichArt === 'KOMMUNIKATION'
            ? 'Vorhandene Kommunikation übernommen'
            : 'Archivierung abgeglichen',
        description:
          item.details.abgleichArt === 'KOMMUNIKATION'
            ? `OPM hat die vorhandene Powercloud-Kommunikation ${item.details.kundenkommunikationId} zu Archiv ${item.details.archivId} übernommen.`
            : 'OPM hat den Powercloud-Bestand automatisch mit dem Quelldokument abgeglichen.',
        initiator: item.user,
        color: 'secondary',
        status: 'completed',
        icon: <RotateCcw />,
      },
    ];
  }
  // Generated clients can lag newly introduced history actions.
  if (String(item.action) === VorgangProtokollAction.PERSISTENCE_RECONCILED) {
    return [
      {
        date: new Date(item.date),
        title: 'Abschluss nachgetragen',
        description:
          'Die Verarbeitung war abgeschlossen. Der Abschluss wurde nach einem Datenbankfehler nachgetragen.',
        initiator: item.user,
        color: 'secondary',
        status: 'completed',
        icon: <RotateCcw />,
      },
    ];
  }
  if (item.action === VorgangProtokollAction.DELETED) {
    return [
      {
        date: new Date(item.date),
        title: TRANSLATION_MAP[item.action],
        description: 'Vorgang wurde gelöscht',
        initiator: item.user,
        status: 'completed',
        icon: <Trash2 />,
        color: 'destructive',
      },
    ];
  }

  if (item.action === VorgangProtokollAction.RESTORED) {
    return [
      {
        date: new Date(item.date),
        title: TRANSLATION_MAP[item.action],
        description: 'Vorgang wurde wiederhergestellt',
        initiator: item.user,
        color: 'secondary',
        status: 'completed',
        icon: <RotateCcw />,
      },
    ];
  }

  if (item.action === VorgangProtokollAction.VORGANG_ZURUECKGESTELLT) {
    return [
      {
        date: new Date(item.date),
        title: TRANSLATION_MAP[item.action],
        description: (
          <p>
            Vorgang wurde zurückgestellt.
            <br /> Kommentar: {item.details.kommentar}
          </p>
        ),
        initiator: item.user,
        color: 'tertiary',
        status: 'error',
        icon: <ArrowLeft />,
      },
    ];
  }

  return [];
};
